<mat-form-field>
  <mat-label>Select</mat-label>
  <mat-select (openedChange)="openedChange($event)" [formControl]="selectFormControl" multiple>
    <mat-select-trigger>
      {{selectFormControl.value ? selectFormControl.value[0] : ''}}
      @if (selectFormControl.value?.length > 1) {
        <span class="additional-selection">
          (+{{selectFormControl.value.length - 1}} {{selectFormControl.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    <div class="select-container">
      <mat-optgroup>
        <mat-form-field style="width:100%;">
          <mat-label>Search</mat-label>
          <input #search autocomplete="off" aria-label="Search" matInput [formControl]="searchTextboxControl">
          @if (search.value) {
            <button [disableRipple]="true" matSuffix mat-icon-button aria-label="Clear"
              (click)="clearSearch($event)">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </mat-optgroup>
      @if ((filteredOptions | async).length == 0) {
        <mat-optgroup>
          <div>No results found!</div>
        </mat-optgroup>
      }
      @for (option of filteredOptions | async; track option) {
        <mat-option (onSelectionChange)="selectionChange($event)"
          [value]="option">
          {{option}}
        </mat-option>
      }
    </div>
  </mat-select>
</mat-form-field>
@if (selectFormControl.value) {
  <div>{{ 'You have choosen ' + selectFormControl.value }}</div>
}